import { useContext, forwardRef } from "react";
import { AddressContext } from "../contexts/AddressContext";
import { ParameterContext } from "../contexts/ParameterContext";
import { Wish } from "./Wish";

export const AutomaticSetAddresses = forwardRef(({ formData, wishChangeHandler, removeWish, isEdit, cleanSiblingInputFields, onBlurWishHandler, addWish, setAutoSedGroup }, ref) => {
    const { advSchools } = useContext(AddressContext);
    const { parameters } = useContext(ParameterContext);

    const messageParam = parameters.nomParameters.find(x => x.param_name == 'DESIRES_MESSAGE');

    const formdatDate = (dateString) => {
        if (!dateString) {
            return '';
        }

        const date = new Date(dateString);

        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();

        return `${day}.${month}.${year}`;
    }

    const showPermanentResidenceDate = () => {
        if (formData.permanentAddress && formData.permanentAddress.residence) {
            return formdatDate(formData.permanentAddress.residence)
        } else if (formData.permanentAddress && formData.permanentAddress.residence == null) {
            return formdatDate(formData.childPermAddressDate);
        } else {
            return '';
        }
    }

    const showCurrentResidenceDate = () => {
        if (formData.currentAddress && formData.currentAddress.residence && formData.currentAddress.addresS_TEXT.trim() !== '') {
            return formdatDate(formData.currentAddress.residence)
        } else if (formData.currentAddress && formData.currentAddress.residence == null) {
            return formdatDate(formData.childCurrAddressDate);
        } else {
            return '';
        }
    }

    return (
        <>
            <div ref={ref} className="htext_ch">Училища</div>
            <div className="children_data d-flex flex-wrap flex-col gap-1 mb-2 p-3-mob">
                {formData.permanentAddress &&
                    <div className="d-flex w-100 justify-content-between">
                        <p className="school-child-address"><b>Постоянен адрес:</b> {formData.permanentAddress ? formData.permanentAddress.addresS_TEXT : ''}</p>
                        <p className="text-right-mob w-35-mob"><b>Регистриран на:</b> {showPermanentResidenceDate()}</p>
                    </div>
                }
                <div className="d-flex w-100 justify-content-between">
                    <p className="school-child-address"><b>Настоящ адрес:</b> {formData.currentAddress ? formData.currentAddress.addresS_TEXT : ''}</p>
                    <p className="text-right-mob w-35-mob"><b>Регистриран на:</b> {showCurrentResidenceDate()}</p>
                </div>
                {messageParam?.value &&
                    <div className="d-flex w-100 justify-content-between">
                        <p className="school-child-address w-100">{messageParam?.value}</p>
                    </div>    
                }
            </div>
            <div className="children_data d-flex flex-wrap gap-1 mb-2 p-3-mob">
                <p className="pa-na-color"><b>Училища за които имате предимство по ПА и НА: </b></p>
                {advSchools.length > 0 && advSchools.map(x => <p className="pa-na-color">{x.name}; </p>)}
            </div>
            <div className="children_data p-3-mob">
                {formData.wishes.map((x, i) =>
                    <Wish
                        formData={formData}
                        handleChange={wishChangeHandler}
                        wish={x}
                        key={x.id}
                        index={i}
                        removeWish={removeWish}
                        isEdit={isEdit}
                        cleanSiblingInputFields={cleanSiblingInputFields}
                        onBlurWishHandler={onBlurWishHandler}
                        setAutoSedGroup={setAutoSedGroup}
                    />)}
                <div className="w-100 d-flex gap-3">

                    <div className="flex-col flex-wrap mt-3 ">
                        <button id="" className="btn but_add mb-3 mt-3" onClick={addWish}>Добави желание</button>
                    </div>

                </div>

            </div>
        </>
    )
})